import { FormEvent } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useMutation } from '@tanstack/react-query'
import apiService from '../../../utils/helpers/apiService'
import PasswordInput from '../../Common/PasswordInput/PasswordInput'
import toast from 'react-hot-toast'
import Logo from '../../Common/Logo/Logo'

const Callback: React.FC = () => {
  const router = useRouter()
  const { email, token } = router.query

  const forgotPasswordMutation = useMutation({
    mutationFn: (password: string) => {
      return apiService.post({
        url: '/users/forgot-password/?check_token=true',
        config: {
          data: {
            email,
            password,
            token,
          },
        },
        withToken: false,
      })
    },
    onSuccess: () => {
      toast.success('Password changed successfully')
      router.push('/auth')
    },
  })

  const onSubmitHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const newPassword = e.currentTarget.new.value
    const confirmNewPassword = e.currentTarget.confirm.value
    if (newPassword !== confirmNewPassword) {
      toast.error('Passwords do not match')
      return
    }
    forgotPasswordMutation.mutate(newPassword)
  }

  return (
    <>
      <Stack
        className="default-form"
        width={1}
        component={'form'}
        onSubmit={onSubmitHandler}
      >
        <Box mb={5}>
          <Link href={'https://jobin.ai'}>
            <Logo />
          </Link>
        </Box>
        <Typography variant="h5_xl" mb={2.5}>
          Choose a New Password
        </Typography>
        <Stack spacing={3.75}>
          <Typography variant="body_m_regular" color={'darkGray.main'}>
            To secure your account, choose a strong password of at least 8
            characters long.
          </Typography>
          <Box>
            <PasswordInput
              id="new"
              name="new"
              placeholder="Password"
              required
              label="New Password"
            />
          </Box>
          <Box>
            <PasswordInput
              id="confirm"
              name="confirm"
              placeholder="Password"
              label="Confirm New Password"
              required
            />
          </Box>
          <Button type="submit">Change Password</Button>
        </Stack>
      </Stack>
    </>
  )
}

export default Callback
